
import React from 'react';
import ZProps from './zprops';
import AMC from './AMC';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCrown } from '@fortawesome/free-solid-svg-icons'

export default class ZooKudosButton extends React.Component {
	constructor(props) {
		super(props);
		this.state = { selected: (ZProps.get(this.props.user.uri + ".history_with_user") || {}).kudo };
	}
	kudos() {
		let { user } = this.props;
		let { selected } = this.state;
		AMC.relate(user.uri, "kudo", (err) => {
			user.kudos = Math.max(0, (user.kudos || 0) + (selected ? -1 : 1));
			this.setState({ selected: !selected });
		});
	}
	render() {
		let { user } = this.props;
		let { selected } = this.state;
		return (
			<div className={"HScoreButton" + (selected ? " BUTTON_SELECTED_COLOR" : "")} onClick={this.kudos.bind(this)}>
			<div className="HScoreButtonLabel" aria-label="Give kudos to this author" title={"Give kudos to " + user.name}>
				<FontAwesomeIcon icon={faCrown} />
				Kudos
			</div>
			<div className="HScoreButtonCount" aria-label={user.kudos + " kudos given to this author"}>{user.kudos || 0}</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/ZooKudosButton.js